import { render, staticRenderFns } from "./InitialRequirements.vue?vue&type=template&id=263e4c38&"
import script from "./InitialRequirements.vue?vue&type=script&lang=ts&"
export * from "./InitialRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports